import React, { useEffect } from 'react';

const TextType = ({ 
    query, index,
    updateOptionValue
}) => {
    useEffect(() => {

    }, [query]);

    const onTextUpdate = (index, value) => {
        updateOptionValue(index, value)
    }

    return (
        <div>
            {
                (query?.operator && query?.operator !== '') ? 
                    <input value={query?.value} onChange={(e) => onTextUpdate(index, e.target.value)} className="form-control border-light rounded" type="text" /> : null
            }
        </div>
    )
};

export default TextType; 